
export const content = {
  en: {
    hero: {
      status: "Available for new projects",
      name: "Michal Folprecht",
      role: "Prestashop Expert & Backend Developer",
      headline: "Building high-performance e-commerce solutions.",
      desc: "I specialize in Prestashop custom development, Nette framework applications, and scalable backend architecture. With over 10 years of experience, I help businesses grow with robust code.",
      cta: "Scroll for my work",
    },
    projects: {
      title: "Own Projects",
      visit: "Visit Website",
      items: [
        {
          title: "Prestaservis.cz",
          subtitle: "Prestashop Development",
          desc: "I provide comprehensive development and maintenance services for e-shops built on the open-source Prestashop platform. My focus includes custom module development, performance optimization for high-traffic stores, and resolving complex technical issues. I help clients scale their businesses by ensuring their e-commerce infrastructure is secure, fast, and reliable.",
          link: "https://prestaservis.cz",
          image: "/prestaservis.webp",
        },
        {
          title: "Oplero.com",
          subtitle: "Project Management Software",
          desc: "Oplero is a robust project management tool designed to streamline workflow and enhance team collaboration. It features intuitive task tracking, time management, and detailed reporting capabilities tailored for agile teams. Built with the Nette framework, it offers a secure and responsive interface that adapts to various project methodologies.",
          link: "https://oplero.com",
          image: "/oplero.webp",
        },
        {
          title: "Postmatico",
          subtitle: "Social Media Scheduler",
          desc: "Postmatico is an automated scheduling platform that simplifies social media and blog content management. It allows users to plan, visualize, and auto-publish content across multiple channels from a single dashboard. The tool integrates AI-driven suggestions to optimize posting times and engagement, saving creators hours of manual work.",
          link: "#",
          image: "/postmatico.webp",
        },
      ],
    },
    experience: {
      title: "Experience",
      items: [
        {
          title: "Freelance Developer",
          subtitle: "2014 – Present",
          desc: "Senior PHP Specialist & Consultant",
          link: null,
          icon: "code",
        }
      ]
    },
    contact: {
      email: "info@michalfolprecht.com",
      label: "Get in touch",
      social: "Follow me on X",
      socialLink: "https://x.com/michalfolprecht",
      linkedin: "Connect on LinkedIn",
      linkedinLink: "https://www.linkedin.com/in/michal-folprecht-75373288",
    },
  },
  cz: {
    hero: {
      status: "K dispozici pro nové projekty",
      name: "Michal Folprecht",
      role: "Prestashop Expert & Backend Vývojář",
      headline: "Stavím výkonná e-commerce řešení.",
      desc: "Specializuji se na zakázkový vývoj pro Prestashop, aplikace v Nette a škálovatelnou backend architekturu. S více než 10 lety zkušeností pomáhám firmám růst díky robustnímu kódu.",
      cta: "Ukázat projekty",
    },
    projects: {
      title: "Vlastní Projekty",
      visit: "Navštívit web",
      items: [
        {
          title: "Prestaservis.cz",
          subtitle: "Vývoj a správa Prestashopu",
          desc: "Poskytuji komplexní vývoj a správu e-shopů postavených na open-source platformě Prestashop. Zaměřuji se na vývoj modulů na míru, optimalizaci výkonu pro vysoce navštěvované obchody a řešení složitých technických problémů. Pomáhám klientům škálovat jejich podnikání tím, že zajišťuji bezpečnost, rychlost a spolehlivost jejich e-commerce infrastruktury.",
          link: "https://prestaservis.cz",
          image: "/prestaservis.webp",
        },
        {
          title: "Oplero.com",
          subtitle: "Software pro řízení projektů",
          desc: "Oplero je robustní nástroj pro řízení projektů navržený pro zefektivnění pracovních postupů a zlepšení týmové spolupráce. Nabízí intuitivní sledování úkolů, time management a podrobné reportování přizpůsobené pro agilní týmy. Postaveno na frameworku Nette, poskytuje bezpečné a responzivní rozhraní, které se přizpůsobí různým metodikám řízení projektů.",
          link: "https://oplero.com",
          image: "/oplero.webp",
        },
        {
          title: "Postmatico",
          subtitle: "Plánovač sociálních sítí",
          desc: "Postmatico je automatizovaná plánovací platforma, která zjednodušuje správu obsahu pro sociální sítě a blogy. Umožňuje uživatelům plánovat, vizualizovat a automaticky publikovat obsah na více kanálech z jednoho dashboardu. Nástroj integruje AI návrhy pro optimalizaci časů publikování a zvýšení dosahu, čímž tvůrcům šetří hodiny manuální práce.",
          link: "#",
          image: "/postmatico.webp",
        },
      ],
    },
    experience: {
      title: "Zkušenosti",
      items: [
        {
          title: "Freelance Vývojář",
          subtitle: "2014 – Současnost",
          desc: "Senior PHP Specialista & Konzultant",
          link: null,
          icon: "code",
        }
      ]
    },
    contact: {
      email: "info@michalfolprecht.com",
      label: "Napište mi",
      social: "Sledujte mě na X",
      socialLink: "https://x.com/michalfolprecht",
      linkedin: "Spojit na LinkedIn",
      linkedinLink: "https://www.linkedin.com/in/michal-folprecht-75373288",
    },
  },
};
